import React, { useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Solutions from "./components/Solution";
import About from "./components/About";
import Contact from "./components/Contact";
import PreOrderModal from "./Modal/PreOrderMoal";
import Footer from "./components/Footer";
import { ToastContainer } from 'react-toastify';
function App() {
  const [preOrderOpen, setPreOrderOpen] = useState(false);

  return (
    <div className="font-sans bg-gray-900 text-gray-200">
      <Header scrollTo={(id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" })} />
      <main id="main-content">
        <Hero openPreOrder={() => setPreOrderOpen(true)} />
        <Solutions />
        <About />
        <Contact />
        <Footer />
      </main>
      <PreOrderModal isOpen={preOrderOpen} onClose={() => setPreOrderOpen(false)} />
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}

export default App;
